export const MAXIMUM_BTC_DEPOSIT_AMOUNT = 999;
